import { Injectable } from "@angular/core";
import { LoggingService } from "../logging.service";
import { NavigationEnd, NavigationError, NavigationStart, Router } from "@angular/router";

@Injectable()
export class NavigationLoggerService {
  private _previousUrl: string = '';
  private _startTime: number;
  constructor(private logger: LoggingService, private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this._previousUrl = this.router.url;
        this._startTime = Date.now();
      }
      if (event instanceof NavigationEnd) {
        const from = this._previousUrl
        const to = event.urlAfterRedirects;
        if (from === to) return; // no navigation happened, reduce logs fatigue
        this.logger.logNavigation({
          from,
          to,
          duration: Date.now() - this._startTime
        })
      }
      else if (event instanceof NavigationError) {
        this.logger.logError({
          context: 'NAVIGATION_ERROR',
          message: event.error.message,
          stack: event.error.stack,
          navigation: {
            from: this.router.url,
            to: event.url,
            duration: Date.now() - this._startTime
          }
        })
      }
    })
  }
}